import React, { Component } from 'react';
import Modal from 'react-modal';
import { Loader } from 'ui/components';
import { inject, observer } from 'mobx-react';
import { observable, runInAction, action } from 'mobx';
import PropTypes from 'prop-types';
import Pdf from 'ui/assets/images/icons/pdf-file-format-symbol.svg';
import Excel from 'ui/assets/images/icons/excel_download.svg';
import { FormattedMessage, getMessagesForLocale } from 'ui/i18n';

import './DownloadModal.scss';

@inject('ProductsState', 'AppState')
@observer
export default class DownloadModal extends Component {
	static propTypes = {
		showDownloadModal: PropTypes.bool.isRequired,
		toggleModal: PropTypes.func.isRequired,
		ProductsState: PropTypes.object.isRequired,
		AppState: PropTypes.object.isRequired,
		promotionId: PropTypes.number,
		categoryId: PropTypes.number,
		name: PropTypes.string,
	};
	static defaultProps = {
		name: '',
		categoryId: -1,
		promotionId: null,
	};

	@observable downloadUrl = '';
	@observable isLoading = false;
	@observable fileName = '';

	getFileName(url) {
		return url.substring(url.lastIndexOf('/') + 1, url.length);
	}

	buildOrigin() {
		return `${window.location.protocol}//${window.location.host}`;
	}

	@action
	handleDownload(extension) {
		const isPdf = extension === 'pdf';
		this.isLoading = true;
		this.downloadUrl = '';
		this.props.ProductsState
			.fetchDownloadPromotion(
				this.props.promotionId,
				isPdf,
				this.props.categoryId
			)
			.then(() => {
				runInAction(() => {
					this.isLoading = false;
					this.downloadUrl = `${this.buildOrigin()}/${this.props.ProductsState
						.fetchDownloadPromotion.state.result.Path}`;
					this.fileName = this.getFileName(this.downloadUrl);
				});
				this.props.toggleModal();
			});
	}

	@action
	downloadFile(elem) {
		if (elem) {
			if (this.downloadUrl) {
				if (!window.ActiveXObject && 'ActiveXObject' in window) {
					window.open(this.downloadUrl, '_blank');
				} else {
					elem.click();
				}

				this.downloadUrl = '';
			}
		}
	}

	handleToggle() {
		this.props.toggleModal();
	}

	handleClick(e) {
		e.stopPropagation();
	}

	render() {
		const IS_PROMOTION = -1;
		const { locale } = this.props.AppState;

		const file =
			this.props.categoryId === IS_PROMOTION
				? getMessagesForLocale(locale)['downloadPromotion.promotionText']
				: getMessagesForLocale(locale)['downloadPromotion.categoryText'];
		return (
			<Modal
				overlayClassName="ReactModal__overlay"
				className="ReactModal__Content DownloadModal"
				isOpen={this.props.showDownloadModal}
				onRequestClose={this.handleToggle.bind(this)}
				contentLabel="Select the download format"
			>
				<span className="DownloadModal_title">
					<FormattedMessage id="leftSideMenu.downloadSoloDetails" />
				</span>
				<hr />
				{this.isLoading
					? <div>
							<Loader />
						</div>
					: <div>
							<p className="DownloadModal_downloadMessage">
								<FormattedMessage id="downloadPromotion.clickOnTypeMessage" />
								{this.props.name} {file}
							</p>
							<div className="DownloadModal_DownloadIcons">
								<div
									className="DownloadModal_download-link"
									onClick={this.handleDownload.bind(this, 'pdf')}
								>
									<img className="DownloadModal_download-img" src={Pdf} />
									<FormattedMessage id="downloadPromotion.downloadPDF" />
									<a
										ref={elem => this.downloadFile(elem)}
										href={this.downloadUrl}
										download={this.fileName}
										onClick={this.handleClick.bind(this)}
										target="_blank"
									/>
								</div>

								<div
									className="DownloadModal_download-link"
									onClick={this.handleDownload.bind(this, 'excel')}
								>
									<img className="DownloadModal_download-img" src={Excel} />
									<FormattedMessage id="downloadPromotion.downloadExcel" />
									<a
										ref={elem => this.downloadFile(elem)}
										href={this.downloadUrl}
										download={this.fileName}
										onClick={this.handleClick.bind(this)}
										target="_blank"
									/>
								</div>
							</div>

							<button
								className="btn btn-default DownloadModal_CancelButton pull-right"
								onClick={this.handleToggle.bind(this)}
							>
								<FormattedMessage id="general.cancelText" />
							</button>
						</div>}
			</Modal>
		);
	}
}



// WEBPACK FOOTER //
// ./src/ui/components/DownloadModal/index.js